/**
 * PostHog engagement events — Renpho AU theme global JS.
 * Loaded from layout/theme.liquid with `defer`. DOM is ready at execution.
 *
 * B2 (add_to_cart) lives inline in <head> so the fetch wrapper is installed
 * before any add-to-cart button is interactive. This file only handles
 * B3 (cart_viewed), B4 (checkout_started), B5 (scroll_depth) which all
 * react to user gestures that necessarily happen after DOMContentLoaded.
 */
(function () {
  if (window.__renphoEngagementBound) return;
  window.__renphoEngagementBound = true;

  function safeCapture(eventName, props) {
    try {
      var ph = window.posthog;
      if (ph && typeof ph.capture === 'function') {
        ph.capture(eventName, props || {});
      }
    } catch (_e) {
      /* swallow — tracking must never break the page */
    }
  }

  function shopifyCurrency() {
    var sh = window.Shopify;
    return (sh && sh.currency && sh.currency.active) || 'AUD';
  }

  function cartSummary(cart) {
    var items = (cart && cart.items) || [];
    return {
      cart_value:
        cart && typeof cart.total_price === 'number' ? cart.total_price / 100 : null,
      items: cart ? cart.item_count : 0,
      product_ids: items.map(function (i) {
        return i.product_id;
      }),
      currency: (cart && cart.currency) || shopifyCurrency()
    };
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  // ---------------------------------------------------------------------------
  // B3: cart_viewed — fire whenever the AU cart drawer opens, or the user
  // lands on /cart. The AU theme renders <cart-drawer id="mini-cart"> which
  // gains an `open` attribute (set by the DrawerContent base class) when
  // shown — observe that attribute to catch trigger clicks AND auto-opens
  // following add-to-cart.
  // ---------------------------------------------------------------------------
  var cartViewedFiring = false;
  function captureCartViewed() {
    if (cartViewedFiring) return;
    cartViewedFiring = true;
    fetchCart().then(function (cart) {
      safeCapture('cart_viewed', cartSummary(cart));
      cartViewedFiring = false;
    });
  }

  if (
    window.location.pathname === '/cart' ||
    window.location.pathname.indexOf('/cart?') === 0
  ) {
    captureCartViewed();
  }

  function bindCartDrawerObserver() {
    var drawer = document.querySelector('cart-drawer, #mini-cart');
    if (!drawer) return false;
    var wasOpen = drawer.hasAttribute('open');
    new MutationObserver(function () {
      var nowOpen = drawer.hasAttribute('open');
      if (nowOpen && !wasOpen) captureCartViewed();
      wasOpen = nowOpen;
    }).observe(drawer, { attributes: true, attributeFilter: ['open'] });
    return true;
  }

  if (!bindCartDrawerObserver()) {
    var bodyObserver = new MutationObserver(function () {
      if (bindCartDrawerObserver()) bodyObserver.disconnect();
    });
    if (document.body) {
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  // Fallback click selector for cart links / cart-trigger headers in case the
  // drawer is removed from DOM by a theme variant.
  document.addEventListener(
    'click',
    function (e) {
      var target = e.target;
      if (!(target instanceof Element)) return;
      // Skip clicks inside cart-drawer itself — the drawer observer handles those.
      if (target.closest('cart-drawer, #mini-cart')) return;
      var trigger = target.closest(
        'a[href="/cart"], a[href^="/cart?"], ' +
          '[aria-controls="mini-cart"], ' +
          '[data-cart-trigger], [data-action="open-cart"]'
      );
      if (trigger) captureCartViewed();
    },
    true
  );

  // ---------------------------------------------------------------------------
  // B4: checkout_started — replace fragile autocapture text-match with a named event.
  // ---------------------------------------------------------------------------
  document.addEventListener(
    'click',
    function (e) {
      var target = e.target;
      if (!(target instanceof Element)) return;
      var trigger = target.closest(
        'button[name="checkout"], input[name="checkout"], ' +
          'a[href^="/checkout"], a[href*="/checkouts/"], ' +
          '[data-checkout], [data-checkout-button]'
      );
      if (!trigger) return;
      fetchCart().then(function (cart) {
        safeCapture('checkout_started', cartSummary(cart));
      });
    },
    true
  );

  // ---------------------------------------------------------------------------
  // B5: scroll_depth — fire 25/50/75/100% once per page, throttled with rAF.
  // ---------------------------------------------------------------------------
  (function () {
    var thresholds = [25, 50, 75, 100];
    var fired = {};
    var ticking = false;

    function templateName() {
      var cls = (document.body && document.body.getAttribute('class')) || '';
      var m = cls.match(/template-([a-z0-9_-]+)/i);
      return m && m[1] ? m[1] : 'unknown';
    }

    function measure() {
      ticking = false;
      var docEl = document.documentElement;
      var scrollTop = window.pageYOffset || docEl.scrollTop || 0;
      var viewport = window.innerHeight || docEl.clientHeight;
      var fullHeight = Math.max(
        docEl.scrollHeight,
        document.body ? document.body.scrollHeight : 0
      );
      if (fullHeight <= 0) return;
      var pct = Math.round(((scrollTop + viewport) / fullHeight) * 100);
      thresholds.forEach(function (t) {
        if (pct >= t && !fired[t]) {
          fired[t] = true;
          safeCapture('scroll_depth', { percent: t, template: templateName() });
        }
      });
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(measure);
      },
      { passive: true }
    );

    // Reset on bfcache restore so the next view starts fresh.
    window.addEventListener('pageshow', function (ev) {
      if (ev.persisted) {
        fired = {};
        measure();
      }
    });
  })();
})();
